import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { CheckCircleOutlined, CommentOutlined, ExclamationCircleFilled, EyeInvisibleOutlined, DeleteOutlined, LoadingOutlined, CloseCircleOutlined, SendOutlined, ClockCircleOutlined, WarningOutlined, MoneyCollectTwoTone, GlobalOutlined } from '@ant-design/icons';
import { Switch, Breadcrumb, Drawer, Button, Space, Modal, Tabs, message, Spin, Statistic, Row, Col, Table, Tag, Tooltip, Alert } from 'antd';
import CountUp from 'react-countup';
import { AutoReply, AutoHide, AutoDelete } from "../../comps/automate/main";
import { useParams } from 'react-router';
import callAPI from "../../comps/fetch/main";
import { LinuxOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { BsCursor } from "react-icons/bs";

import generateInsights from "../../funcs/genrateInsights";



const formatter = (value) => <CountUp end={value} separator="," />;
const { confirm } = Modal;

function Automations() {
    const [messageApi, contextHolder] = message.useMessage();

    const [showDrawer, setShowDrawer] = useState(false)
    const [DrawerType, setDrawerType] = useState("")
    const [toogle, setToogle] = useState(true)

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState()
    const [initalState, setInitalState] = useState()
    const params = useParams()

    const [callPostAPi, setCallPostApi] = useState(false)
    const [posting, setPosting] = useState(false)
    const [dataPostedState, setDataPostedState] = useState()
    const [disableSection, setDisableSection] = useState()
    const [dashboardAPIData, setDashboardAPIData] = useState()

    const [postComments, setPostComments] = useState()

    const [postCommentsList, setPostCommentsList] = useState([])
    const [commentsLoading, setCommentsLoading] = useState(false)

    const [commentPagination, setCommentPagination] = useState()

    const [commentPaginationPageChange, setCommentPaginationPageChange] = useState(0)

    const [showPlan, setShowPlan] = useState(false)

    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const post_type = urlParams.get('post_type') || "posts";

    const flow_editor =  urlParams.get('flow_editor') || false;

    useEffect(() => {
        if (!callPostAPi || callPostAPi == undefined || callPostAPi == false) {
            return
        }
        messageApi.open({
            type: 'loading',
            content: 'Please wait updating',
            duration: 0,
        });
        let payload = { ...data }

        

        payload["auto_reply"]["enable"] = disableSection ? false : true

        let apiURL = post_type == "next-post" ? `next-post` : `automate-post`
        console.log("payload======", payload)
        localStorage.setItem("previous_config", JSON.stringify(payload))
        callAPI({ url: apiURL, method: "POST", body: payload, loadingState: setLoading, dataState: setDataPostedState })
        setCallPostApi(false)


    }, [callPostAPi])

    useEffect(() => {
        if (dataPostedState == undefined) {
            return
        }

        messageApi.destroy()
        if (dataPostedState.code != 200) {
            message.error("Something went wrong please try again later.")
            // Error
        }
        else {
            // Success and close the drwaer
            setShowDrawer(false)
            setDrawerType('')

            if (disableSection) {
                message.success("Automation Updated")
                message.loading("Refreshing Page")
                setTimeout(() => {
                    window.location.reload();
                  }, 2000);
            }
            else {
                message.success("Automation is live")
                message.loading("Refreshing Page")
                setTimeout(() => {
                    window.location.reload();
                  }, 2000);
            }
            setDisableSection(false)
        }

    }, [dataPostedState])



    function ComingSoon() {
        return (<div className="cs" style={{ width: '100%', height: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
            <LinuxOutlined style={{ fontSize: '40px' }} />
            <p style={{ fontSize: '20px' }}>coming soon</p></div>)
    }

    let drawerTypeObj = {
        reply: {
            title: post_type == "stories" ? "Auto Reply to Story" : "Auto Reply to Comments",
            comp: <AutoReply state={{ ...data }} setData={setData} isStory={post_type == "stories"} isNextPostReply={post_type == "next-post"} setShowplan={setShowPlan} showPlan={showPlan} />
        },
        hide: {
            title: "Auto Hide Comments",
            comp: <ComingSoon />
            // comp: <AutoHide state= {{...data}} setData = {setData} />
        },
        delete: {
            title: "Auto Delete Comments",
            comp: <ComingSoon />
            // comp: <AutoDelete state= {{...data}} setData = {setData} />
        },
    }

    useEffect(() => {

        if (DrawerType == "reply") {

        }
        if (DrawerType == "hide") {

        }
        if (DrawerType == "delete") {

        }

    }, [DrawerType])

    useEffect(() => {

        if (dashboardAPIData == undefined) {
            return
        }
        // console.log("==========", dashboardAPIData)
        if (dashboardAPIData?.data != undefined) {
            setDashboardAPIData({ ...dashboardAPIData?.data })
        }
        // console.log("===========dahboard api data" , dashboardAPIData)
    }, [dashboardAPIData])


    useEffect(() => {

        if (postComments == undefined) {
            return
        }
        if (postComments?.data != undefined) {
            setCommentPagination(postComments?.data?.pagination?.comment_id)
            setPostCommentsList([...postCommentsList, ...postComments?.data?.items])

        }
    }, [postComments])

    useEffect(() => {
        if (commentPaginationPageChange == 0) {
            return
        }
        let commentsURL = `ig-post-comments?post_id=${params.id}&last_comment_id=${commentPagination}&only_error=true`
        callAPI({ url: commentsURL, method: "GET", loadingState: setCommentsLoading, dataState: setPostComments })

    }, [commentPaginationPageChange])


    useEffect(() => {
        if (data == undefined) {
            return
        }

        if (data.data != undefined) {
            let tempData = data.data
            tempData.auto_reply.buttons = tempData.auto_reply.buttons || [{ "title": "click to edit", "url": "", "type": "web_url" }]
            setData({ ...data.data })
            setInitalState({ ...data.data })
        }


    }, [data])

    useEffect(() => {
        if (loading == true && data != undefined) {
            return
        }
        let tem_post_type = urlParams.get('post_type') || "posts";
        let apiURL = tem_post_type == "next-post" ? `next-post?post_id=${params.id}` : `automate-post?post_id=${params.id}`
        callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

        if (tem_post_type != "next-post") {
            let apiURLDashboard = `post-dashboard?post_id=${params.id}`
            callAPI({ url: apiURLDashboard, method: "GET", loadingState: setLoading, dataState: setDashboardAPIData })

            let commentsURL = `ig-post-comments?post_id=${params.id}`
            callAPI({ url: commentsURL, method: "GET", loadingState: setCommentsLoading, dataState: setPostComments })

        }

        setDrawerType('')
    }, [])

    const showConfirm = (action_name) => {
        confirm({
            title: `Are you sure want to disable ${action_name}?`,
            icon: <ExclamationCircleFilled />,
            content: 'You can enable at anytime with current configuration.',
            okText: "Disable",
            cancelText: 'Cancel',
            onOk() {

                setDisableSection(true)
                setCallPostApi(true)
            },
            onCancel() {

            },
        });
    };

    function HandlePublish() {


        let error = 0

        if (data["auto_reply"]["collect_money"] == true ) {

            if (data["auto_reply"]["payment_details"] == undefined){
                message.error("Product Details Missing")
                error+=1
            }
            
            if(data["auto_reply"]["payment_details"]["product_title"] == undefined || data["auto_reply"]["payment_details"]["product_title"].length <1 ){
                message.error("Product Title Missing")
                error+=1
            }
            if(data["auto_reply"]["payment_details"]["product_description"] == undefined || data["auto_reply"]["payment_details"]["product_description"].length <1 ){
                message.error("Product Title Missing")
                error+=1
            }
            if(data["auto_reply"]["payment_details"]["r_price"] == undefined || data["auto_reply"]["payment_details"]["r_price"] <1 ){
                message.error("Product Price should be more than or equal to 1")
                error+=1
            }
        }


        if (data["auto_reply"]["automate_all"] != "true" && data["auto_reply"]["triger_words"].length < 1) {

            message.error("Missing Trigger words")
            error += 1
        }


        if (data["auto_reply"]["enable_dm_reply"] != false && data["auto_reply"]["automate_all"] != "true") {

            if ((data["auto_reply"]["dm_template_type"] != "button" && data["auto_reply"]["dm_template_type"] != "products") && (data["auto_reply"]["dms"] != undefined && data["auto_reply"]["dms"][0].length < 1)) {
                message.error("Missing DM text")
                error += 1
            }

        }

        if (data["auto_reply"]["enable_comment_reply"] != false && data["auto_reply"]["reply_comments"].length < 1) {

            if (post_type != "stories") {
                message.error("Missing Reply comments words")
                error += 1
            }


        }
        if (error < 1) {

            setCallPostApi(true)

        }
    }

    useEffect(()=>{

        

    },[showPlan])

    function AutomationSetup() {

        if (commentsLoading || data == undefined || data.data != undefined) {
            return <div style={{ width: '100%', height: '100hh', display: 'flex', alignContent: 'center', justifyContent: 'center' }}> <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />Please Wait...</div>
        }
        return (<>
            <h1> {post_type == "stories" ? "Story Automation" : post_type == "next-post" ? "Configure your Next Post automation" : "Post Automations"}</h1>
            <div className="automated-flex">
                <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true);
                        setDrawerType('reply');
                    }
                }} >
                    <Switch value={data.auto_reply.enable} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            setShowDrawer(true); setDrawerType('reply')
                        }

                    }} />
                    <CommentOutlined className="icon reply" />
                    <h4>Auto Reply</h4>
                    {post_type == "stories" ?
                        <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                        :
                        <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                    }
                </div>
                {/* coming soon soon below */}
                <div className="automate-options" onClick={(event) => {
                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true); setDrawerType('hide')
                    }
                }}>
                    <Switch disabled value={data.auto_hide.enable} className="switch" onClick={(value) => {
                        if (value == false) {
                            showConfirm('Auto Hide')
                            // return
                        }
                        else {
                            setShowDrawer(true); setDrawerType('hide')
                        }
                    }} />
                    <EyeInvisibleOutlined className="icon hide" />
                    <h4>Auto Hide / Delete </h4>
                    <p>Automatically hide or delete comments that contain abusive or sensitive language, ensuring a safer and more respectful community for your audience.</p>
                </div> 
            </div>


        </>)
    }

    function ListPostComments() {
        function unixToLocalDateTime(unixTimestamp) {
            const date = new Date(unixTimestamp * 1000); // convert seconds to milliseconds
            return date.toLocaleString([], { hour12: true, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        function convertToLocalDateTime(dateString) {
            
            try{
            
            const date = new Date(dateString);

            // return date.toLocaleTimeString();
            const utcTime = new Date(dateString);

            const localTime = new Date(utcTime + 'Z').toLocaleString([], { hour12: true, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
            
            return localTime
            }
            catch{
                return "-"
            }

        }


        // Utility function to safely access deeply nested properties
        const safeAccess = (fn, fallback = "N/A") => {
            try {
                return fn();
            } catch {
                return fallback;
            }
        };

        // Utility function to get comment text safely
        const getCommentText = (record) => {
            if(record.story_reply){
                return <Tag color="geekblue">DM Reply</Tag>
            }
            return safeAccess(
                () => record.event_dumb.entry[0].changes[0].value.text,
                record.event_dumb.text || "Error fetching comment"
            );
        };

        // Columns definition with safe handling
        const columns = [
            {
                title: 'Insta ID',
                render: (_, record) =>

                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].sender.id,
                                record.event_dumb?.from?.username
                            )}
                        </p>
                    ) : (
                        <p >
                            {safeAccess(
                                () => <a href={`https://instagram.com/${record.event_core.from.username}`} target="_blank">{record.event_core.from.username}</a>
                                
                            )}
                        </p>
                    ),
                key: 'id',
                maxWidth: '100px',
            },
            {
                
                title: 'Status',
                render: (_, record) =>
                (<>
                   {record.ig_rate_limit && <><Tooltip title="Instagram limit reached"> <Tag color="red" icon = {<WarningOutlined/>}> Instagram limit reached</Tag></Tooltip> { !["428337","428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick = {() =>{setShowPlan(true)}}>Upgrade your plan for auto process.</Button>} </> }
                   {record.paid && <> <Tag color="geekblue" icon = {<MoneyCollectTwoTone />}>Paid</Tag></>}
                    {(!record.ig_rate_limit && record.hourly_limit_reached) && <><Tooltip title={ !["428337","428338"].includes(localStorage.getItem("planid")) ? "Hourly limit reached. Upgrade your plan for higher rate limits.":"This comment reached hourly limit, before switching plan."}> <Tag color="red" icon = {<WarningOutlined/>}>Rate limit reached</Tag></Tooltip> { !["428337","428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick = {() =>{setShowPlan(true)}}>Upgrade your plan for higher rate limits.</Button>} </> }
                    {record.waiting && <> <Tooltip title="Waiting in Queue"> <Tag color="geekblue" icon = {<ClockCircleOutlined />}>Scheduled</Tag> </Tooltip> </>}
                    {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded == "true" && <> <Tooltip title="DM Sent"> <Tag color="green" icon =  {<SendOutlined/>}>Sent</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded != "true" && <> <Tooltip title="DM Not Sent"> <Tag color="red" icon =  {<SendOutlined/>}>Failed</Tag> </Tooltip> </>} */}
                    {(!record.hourly_limit_reached && !record.waiting && record.cm_responded == "true" && record.story_reply != true) && <> <Tooltip title="Comment replied"> <Tag color="green" icon = {<CommentOutlined />}>Replied</Tag> </Tooltip> </>}
                    {record.link_opened	 && <> <Tag color="purple" icon = {<BsCursor />}>Link Opened</Tag></>}
                    {/* {(!record.hourly_limit_reached && !record.waiting && !record.waiting && record.cm_responded == "false" && record.story_reply == false) && <> <Tooltip title="Comment not replied"> <Tag color="red" icon = {<CommentOutlined />}>Failed</Tag> </Tooltip> </>} */}
                </>),
                // record.responded ? (
                //     <Tag icon={<CheckCircleOutlined />} color="success">
                //         success
                //     </Tag>
                // ) : (
                //     <Tooltip title="Error" color={'red'} key={'red'}>
                //         <Tag icon={<CloseCircleOutlined />} color="error">
                //             error
                //         </Tag>
                //     </Tooltip>
                // ),
                key: 'responded',
            },
            {
                
                title: <p>City <Tag color="purple">New</Tag> </p>,
                render: (_, record) =>
                (<>
                   {record.city && <p>{record.city}</p>}
                  
                </>),

                key: 'city',
            },
            {
                title: 'Comment',
                render: (_, record) =>
                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].message.text,
                                record.event_dumb.from?.username
                            )}
                        </p>
                    ) : (
                        <p>{getCommentText(record)}</p>
                    ),
                key: 'comment',
            },
            {
                title: 'Responded Time',
                render: (_, record) => record.waiting ? `Sechduled at ${convertToLocalDateTime(record.responded_at)}` : convertToLocalDateTime(record.responded_at) ,
                key: 'rt',
            },
        ];

        // Mobile columns with safe handling
        const mobileColumns = [
            {
                title: 'Insta ID',
                render: (_, record) =>

                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].sender.id,
                                record.event_dumb?.from?.username
                            )}
                        </p>
                    ) : (
                        <p >
                            {safeAccess(
                                () => <a href={`https://instagram.com/${record.event_core.from.username}`} target="_blank">{record.event_core.from.username}</a>
                                
                            )}
                        </p>
                    ),
                key: 'id',
                maxWidth: '100px',
            },
            {
                title: 'Status',
                render: (_, record) =>

                    (<div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
                    {record.ig_rate_limit && <><Tooltip title="Instagram limit reached"> <Tag color="red" icon = {<WarningOutlined/>}> Instagram limit reached</Tag></Tooltip> { !["428337","428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick = {() =>{setShowPlan(true)}}>Upgrade your plan for auto process.</Button>} </> }
                    {(!record.ig_rate_limit && record.hourly_limit_reached) && <><Tooltip title={ !["428337","428338"].includes(localStorage.getItem("planid")) ? "Hourly limit reached. Upgrade your plan for higher rate limits.":"This comment reached hourly limit, before switching plan."}> <Tag color="red" icon = {<WarningOutlined/>}>Rate limit reached</Tag></Tooltip> { ["428337","428338"].includes(localStorage.getItem("planid")) && <Button style={{marginTop:'20px'}} color="primary" variant="outlined" onClick = {() =>{setShowPlan(true)}}>Upgrade for higher rate limit</Button>} </> }
                    {record.paid && <> <Tag color="geekblue" icon = {<MoneyCollectTwoTone />}>Paid</Tag></>}
                    {record.waiting && <> <Tooltip title="Waiting in Queue"> <Tag color="geekblue" icon = {<ClockCircleOutlined />}>Scheduled</Tag> </Tooltip> </>}
                    {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded == "true" && <> <Tooltip title="DM Sent"> <Tag color="green" icon =  {<SendOutlined/>}>Sent</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded != "true" && <> <Tooltip title="DM Not Sent"> <Tag color="red" icon =  {<SendOutlined/>}>Failed</Tag> </Tooltip> </>} */}
                    {(!record.hourly_limit_reached && !record.waiting && record.cm_responded == "true" && record.story_reply != true) && <> <Tooltip title="Comment replied"> <Tag color="green" icon = {<CommentOutlined />}>Replied</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting && !record.waiting && record.cm_responded == "false" && record.story_reply == false) && <> <Tooltip title="Comment not replied"> <Tag color="red" icon = {<CommentOutlined />}>Failed</Tag> </Tooltip> </>} */}
                    {record.link_opened	 && <> <Tag color="purple" icon = {<BsCursor />}>Link Opened</Tag></>}
                    {record.city	 && <> <Tag color="orange" icon = {<GlobalOutlined />}>{record.city}</Tag></>}
                    </div>),
                key: 'responded',
            },

        ];



        if (commentsLoading || postCommentsList.length < 1) {
            return <div style={{ width: '100%', height: '100hh', display: 'flex', alignContent: 'center', justifyContent: 'center' }}> <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />Please Wait...</div>
        }
        
        return (
            <div>
                
                <Table dataSource={postCommentsList}
                    tableLayout="auto"
                    rowKey={(record) => record.comment_id}
                    columns={columns}
                    pagination={false}
                    expandable={{
                        expandRowByClick: false,
                        // defaultExpandAllRows:true,
                        expandedRowRender: (record) => (
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px'
                                    }}
                                >
                                    #id: {record.comment_id} <br/>
                                    {record.paid && <> <Tag color="geekblue" icon = {<MoneyCollectTwoTone />}>Paid</Tag></>}
                                    # DM Sent : {record.waiting? "Scheduled" : record.dm_responded} <br/>
                                    # Link Opened Time : {convertToLocalDateTime(record.link_open_at) == "Invalid Date" ? "NA" : convertToLocalDateTime(record.link_open_at)}
                                </p>
                            </div>
                        ),
                        // rowExpandable: (record) => record.reason !== 'Not Expandable',
                    }}
                    className="desktop"
                />

                <Table dataSource={postCommentsList}
                    tableLayout="auto"
                    rowKey={(record) => record.comment_id}
                    columns={mobileColumns}
                    pagination={false}
                    expandable={{
                        expandRowByClick: true,
                        // defaultExpandAllRows:true,
                        expandedRowRender: (record) => (
                            <div>
                                {post_type != "stories" && <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px'
                                    }}
                                >

                                    Comment :{getCommentText(record)} <br /> <br />
                                    
                                    { record.waiting ? "Sechduled at"  : "Responded at" } {convertToLocalDateTime(record.responded_at)} <br />
                                    #id: {record.comment_id} <br />
                                </p>
                                }
                                {post_type == "stories" && <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px',
                                        overflowX: 'hidden'
                                    }}
                                >

                                    Comment : {record.event_dumb.entry != undefined ? record.event_dumb["entry"][0].messaging[0]["message"]["text"] : record.event_dumb?.text} <br />
                                    Replied at : {convertToLocalDateTime(record.responded_at)} <br />
                                    #id: {record.comment_id.slice(0, 40)} <br />
                                    # Link Opened Time : {convertToLocalDateTime(record.link_open_at) == "Invalid Date" ? "NA" : convertToLocalDateTime(record.link_open_at)}
                                </p>
                                }
                            </div>
                        ),
                        // rowExpandable: (record) => record.reason !== 'Not Expandable',
                    }}
                    className="mobile"
                />
                <Button href="#" onClick={() => setCommentPaginationPageChange(commentPaginationPageChange + 1)} type="primary"
                    style={{ padding: '10px', width: '100px', marginTop: '20px', marginBottom: '20px' }}
                    disabled={postCommentsList.length >= dashboardAPIData?.total_comments}>Load More</Button>
            </div>
        )
    }


    return (
        <div className="page-layout">
            {contextHolder}
            <Sider setShowPlan={setShowPlan} showPlan={showPlan} />



            <div className="page-content">
            { flow_editor =="true" && <Alert
                style={{ marginBottom: '10px', marginTop: '10px' }}
                message="Configured via Flow Editor, but editable!"
                description="This post was set up through the Flow Editor. You can edit it manually, but any modifications will replace the existing Flow Editor settings for this post alone."
                type="warning"
                
                />
            }
                <Breadcrumb
                    style={{ marginTop: '20px' }}
                    separator=">"
                    items={[
                        {
                            title: <Link to="/home">{post_type == "stories" ? "Stories" : post_type == "next-post" ? "Next post" : "Posts"}</Link>,

                        },
                        {
                            title: 'Automation',
                        },
                    ]}
                />

                {post_type != "next-post" && dashboardAPIData?.total_comments != undefined && <Row style={{ marginTop: '20px' }} gutter={18}>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Total DM's" : "Total Comments"} value={dashboardAPIData?.total_comments || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Automated DM's" : "Automated Comments"} value={dashboardAPIData?.total_responded || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Waiting DM's" : "Waiting Comments"} value={dashboardAPIData?.total_waiting || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Skipped DM's" : "Skipped Comments"} value={dashboardAPIData?.limit_reached_count || 'NA'} formatter={formatter} />
                    </Col>
                </Row>
                }
                <Tabs
                    defaultActiveKey="1"
                    items={[{
                        key: 1,
                        label: `Automation Configuration `,
                        children: <AutomationSetup />,
                        icon: '',
                    },
                    post_type != "next-post" && {
                        key: 2,
                        label: post_type == "stories" ? `All DM's` : `All Comments`,
                        children: <ListPostComments />,
                        icon: '',
                    }
                        // {
                        //     key: 3,
                        //     label: `Replied Comments`,
                        //     children: `List of replied Comments`,
                        //     icon: '',
                        // },{
                        //     key: 4,
                        //     label: `Hidden Comments`,
                        //     children: `List of Hidden Comments`,
                        //     icon: '',
                        // },{
                        //     key: 5,
                        //     label: `Deleted Comments`,
                        //     children: `List of Deleted Comments`,
                        //     icon: '',
                        // },
                    ]}
                />
                <Drawer
                    title={drawerTypeObj[DrawerType]?.title}
                    placement="right"
                    open={showDrawer}
                    style={{ backgroundColor: '#f5f5ff' }}
                    width={'600px'}
                    onClose={() => { setShowDrawer(false); setData(initalState) }}
                    extra={
                        DrawerType == "reply" && <Space>
                            <Button onClick={() => { setShowDrawer(false); setData(initalState) }}>Cancel</Button>
                            <Button type="primary"
                                onClick={() => HandlePublish()} loading={posting}>
                                Publish
                            </Button>
                        </Space>
                    }
                >
                    {drawerTypeObj[DrawerType]?.comp}
                </Drawer>
            </div>
        </div>
    )

}

export default Automations;
